// extracted by extract-css-chunks-webpack-plugin
module.exports = {"chikuLoader":"cl0A7ztbmvZ6","spinner":"j-5rS+G3m2Mt","rotate":"+4cVDVYwfR-J","chiku":"AxKq8BqARmdS"};